/** PostHog multivariate flag — 6-month billing option in course payment modal. */
export const COURSE_SIX_MONTH_BILLING_PLAN_FLAG =
  'course_six_month_billing_plan';

/** PostHog multivariate flag — 12-month billing option in course payment modal. */
export const COURSE_TWELVE_MONTH_BILLING_PLAN_FLAG =
  'course_twelve_month_billing_plan';

/** True when the PostHog variant is `test`. */
export const isLongTermBillingPlanVariantEnabled = (
  variant: string | boolean | undefined
): boolean => variant === 'test';
